import {
    type FC,
    type ReactNode,
    useEffect,
    useState,
} from "react";
import FontAwesomeLight from "../../../../app/Utilities/Platform/FontAwesome/FontAwesomeLight";
import { type NavigationType } from "./Navigation";
import { NavigationMenu } from "./NavigationMenu";
import { NavigationSearchResults } from "./Search/NavigationSearchResults";

interface Props {
    path: Array<string>;
    navigation: NavigationType;
}

export const NavigationMobile: FC<Props> = ({ path, navigation }) => {
    const [ open, setOpen ] = useState(false);
    const [ search, setSearch ] = useState("");

    let results: ReactNode | undefined = undefined;

    useEffect(() => {
        setOpen(false);
    }, [ path ]);

    if(search.trim().length) {
        results = (
            <NavigationSearchResults
                search={search}
                navigation={navigation}
                open
                setOpen={(value) => {
                    if(!value) {
                        setSearch("");
                    }
                }}
            />
        );
    } else if(open) {
        results = (
            <div className="py-4">
                <NavigationMenu
                    path={path}
                    navigation={navigation}
                />
            </div>
        );
    }

    return (
        <div className="relative navigation-background">
            <div className="flex h-[67px] w-full p-4 box-border">
                <div className="grow mr-4 form-input mb-0!">
                    <div className="input-icon left">
                        <FontAwesomeLight icon="search" />
                    </div>
                    <input
                        placeholder="Search..."
                        onChange={e => {
                            setSearch(e.currentTarget.value);
                            setOpen(false);
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                        onFocus={(e) => {
                            e.stopPropagation();
                        }}
                    />
                </div>
                <button
                    className={
                        "bg-transparent border-0 text-black text-base px-2 py-0 hover:bg-black/20 rounded-xl " +
                        "cursor-pointer"
                    }
                    onClick={() => {
                        setOpen(prevState => !prevState);
                    }}
                >
                    <FontAwesomeLight
                        icon={
                            open ?
                                "arrow-to-right" :
                                "arrow-from-right"
                        }
                    />
                </button>
            </div>
            {typeof results !== "undefined" && (
                <div
                    className={
                        "absolute h-[calc(100dvh-117px)] overflow-auto w-full py-2 box-border border-0 border-t " +
                        "border-t-solid border-neutral-300 top-full navigation-background z-10"
                    }
                >
                    {results}
                </div>
            )}
        </div>
    );
};
